// extracted by mini-css-extract-plugin
export default {"header":"styles_header__hDTWZ","columnContainer":"styles_columnContainer__zPg-m"};